<template>
    <div v-loading="pageLoading">
        <PageHeader title="采购单详情" hidden-breadcrumb>
            <div slot="back" @click="jumpPrevPage">
                <Icon type="md-arrow-back" />
            </div>
        </PageHeader>
        <div class="bg-white mb-40" v-loading="pageLoading">
            <Card title="采购信息" :bordered="false" dis-hover class="ivu-mt">
                <Form :label-width="100" label-colon>
                    <Row>
                        <Col span="12">
                            <FormItem label="采购单号">{{ detailData.orderNo }}</FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="订单状态">
                                {{ getLabelByValue(purchaseOrderStatusDict, detailData.status) }}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem label="制单人">{{ detailData.submitUser }}</FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="品牌商">{{ detailData.brandingCompany }}</FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem label="制单时间">{{ detailData.submitTime }}</FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="收货地址">{{ detailData.distributorAddress }}</FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <FormItem label="备注">{{ detailData.remark || '-' }}</FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Card title="采购产品" :bordered="false" dis-hover class="ivu-mt">
                <Table
                    :columns="tableConfig.columns"
                    :data="tableConfig.data"
                    show-summary
                    :summary-method="handleSummary"
                ></Table>
            </Card>
        </div>
    </div>
</template>

<script>
import { jumpPage, transPathToName } from '@/libs/util';
import { apiPurchaseOrderDetail } from '@/api/purchase';
import { purchasePruductColumns } from './const';
import { getLabelByValue, purchaseOrderStatusDict } from '@/dicts';

export default {
    data() {
        return {
            getLabelByValue,
            purchaseOrderStatusDict,
            id: this.$route.query.id || '',
            tableConfig: {
                columns: purchasePruductColumns,
                data: [],
                loading: false,
            },
            pageLoading: false,
            detailData: {},
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        jumpPrevPage() {
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: '/sub-vue2/purchase/purchaseOrder/list' });
        },

        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            try {
                const res = await apiPurchaseOrderDetail({ id: this.id });
                res.itemList.map((item, index) => {
                    item.no = index + 1;
                });
                this.tableConfig.data = res.itemList || [];
                this.detailData = res;
            } finally {
                this.pageLoading = false;
            }
        },
        // 合计
        handleSummary({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '合计',
                    };
                    return;
                }
                if (index === 3 || index === 5) {
                    const values = data.map((item) => Number(item[key]));
                    if (!values.every((value) => isNaN(value))) {
                        const v = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[key] = {
                            key,
                            value: v,
                        };
                    } else {
                        sums[key] = {
                            key,
                            value: '',
                        };
                    }
                    return;
                }
                sums[key] = {
                    key,
                    value: '',
                };
            });
            return sums;
        },
    },
};
</script>
